import { useContext } from "react";
import { MnemonicGateReferenceSurfaceContext } from "#mnemonic-gate-reference-surface-context";

/** Whether the calling mnemonic renders on the standalone Reference page. */
export function useIsMnemonicGateReferenceSurface(): boolean {
  return useContext(MnemonicGateReferenceSurfaceContext);
}
